import "./Support.scss";
import { useEffect, useState } from "react";
import ViewIcon from "./../../assets/show-user.svg";
import DeleteUser from "./../../assets/delete.svg";
import NotesIcon from "./../../assets/notes-icon.svg";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import MessageModals from "../../components/MessageModals/MessageModals";
import SwipeableModals from "./SwipeableModals/SwipeableModals";
import api from "../../utils/api";
import SwitchButton from "../../components/SwitchButton/SwitchButton";
import { TextField, useMediaQuery } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { ChatColumns } from "../../SourceData";
import { message } from "antd";

const SupportChat = () => {
  const isMobile = useMediaQuery("(max-width:767px)");
  const [query, setQuery] = useState("");
  const [currentModalView, setCurrentModalView] = useState("changePassword");
  const [openDelete, setOpenDelete] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (query.length >= 2 || query.length === 0) {
        getData();
      }
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [query, page, pageSize]);

  const getData = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page: page + 1,
        limit: pageSize,
        type: "shops",
      });

      if (query.length >= 2) {
        params.append("search", query);
      }

      const res = await api.get(`/support_chats?${params.toString()}`);
      setData(res.data.data);
      setTotalRows(res?.data?.total || 0);
    } catch (error) {
      console.error("Error fetching data:", error);
      message.error("حدث خطأ في تحميل البيانات");
    } finally {
      setLoading(false);
    }
  };

  const handleOpen = (view, rowId = null, rowData = null) => {
    setCurrentModalView(view);
    setSelectedRowId(rowId);
    setSelectedRow(rowData);
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
    setSelectedRowId(null);
    setSelectedRow(null);
  };

  const handlePaginationModelChange = (model) => {
    setPage(model.page);
    setPageSize(model.pageSize);
  };

  // Updated function to toggle finish status using the correct endpoint
  const handleFinishToggle = async (row) => {
    setLoading(true);
    try {
      const newFinishStatus = row.finish === 0 ? 1 : 0;

      await api.put(`/support_chats/${row.id}`, {
        finish: newFinishStatus,
        // support_question_id: row.id,
      });

      await getData(); // Refresh data
      message.success("تم تعديل حالة الدعم بنجاح");
    } catch (error) {
      console.error("Error updating finish status:", error);
      message.error("حدث خطأ في تعديل حالة الدعم");
    } finally {
      setLoading(false);
    }
  };

  const handleDescription = async (description) => {
    setLoading(true);
    try {
      await api.put(`/support_chats/${selectedRowId}`, {
        description: description,
      });
      await getData(); // Refresh data
      message.success("تم اضافة وصف الدعم بنجاح");
      handleClose(); // Close modal after success
    } catch (error) {
      console.error("Error updating description:", error);
      message.error("حدث خطأ في تعديل حالة الدعم");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteChat = async () => {
    if (!selectedRowId) return;

    setLoading(true);
    try {
      await api.delete(`/support_chats/${selectedRowId}`);
      await getData(); // Refresh data
      setOpenDelete(false);
      setSelectedRowId(null);
      message.success("تم حذف المحادثة بنجاح");
    } catch (error) {
      console.error("Error deleting chat:", error);
      message.error("حدث خطأ في حذف المحادثة");
    } finally {
      setLoading(false);
    }
  };

  const actionColumn = [
    {
      field: "finish",
      headerName: "اغلاق المحادثة",
      minWidth: 80,
      headerAlign: "center",
      align: "center",

      renderCell: (params) => {
        const isWorking = params?.row?.finish === 0;
        return (
          <SwitchButton
            checked={isWorking}
            onClick={() => handleFinishToggle(params.row)}
          />
        );
      },
    },
    {
      field: "action",
      headerName: "",
      width: 160,
      headerAlign: "center",
      align: "center",
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="cell-action">
            <div
              className="cell-btn"
              onClick={() =>
                handleOpen("addDescription", params.row.id, params.row)
              }
              title="إضافة ملاحظات"
            >
              <img src={NotesIcon} alt="ملاحظات" />
            </div>

            <div
              className="cell-btn"
              onClick={() => handleOpen("viewChat", params.row.id, params.row)}
              title="عرض المحادثة"
            >
              <img src={ViewIcon} alt="عرض" />
            </div>

            <div
              className="cell-btn"
              onClick={() => {
                setSelectedRowId(params.row.id);
                setOpenDelete(true);
              }}
              title="حذف المحادثة"
            >
              <img src={DeleteUser} alt="حذف" />
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <div className="support">
      <div className="support-header">
        <div className="actions-container">
          <div className="search">
            <TextField
              id="outlined-search"
              type="search"
              value={query}
              placeholder="ابحث..."
              onChange={(e) => setQuery(e.target.value)}
              sx={{
                width: isMobile ? "100%" : "380px",
                borderRadius: "8px",
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </div>
        </div>
      </div>

      <div className="container">
        <DataGrid
          sx={{ backgroundColor: "white", width: "100%" }}
          autoHeight={true}
          columns={ChatColumns.concat(actionColumn)}
          rows={data.map((row, index) => ({
            ...row,
            index: page * pageSize + index + 1,
          }))}
          disableVirtualization
          disableColumnFilter
          disableColumnMenu
          loading={loading}
          paginationMode="server"
          rowCount={totalRows}
          pageSizeOptions={[10, 25, 50]}
          paginationModel={{
            page,
            pageSize,
          }}
          onPaginationModelChange={handlePaginationModelChange}
        />
      </div>

      <MessageModals
        open={openDelete}
        onClose={() => {
          setOpenDelete(false);
          setSelectedRowId(null);
        }}
        onConfirm={handleDeleteChat}
        onDataChange={getData}
        text="تم حذف المحادثة بنجاح"
        currentView="delete"
        route={`/support_chats/${selectedRowId}`}
      />

      <SwipeableModals
        open={isOpen}
        onClose={handleClose}
        onOpen={handleOpen}
        currentView={currentModalView}
        selectedId={selectedRowId}
        selectedRow={selectedRow}
        onDescriptionSubmit={handleDescription}
        loading={loading}
      />
    </div>
  );
};

export default SupportChat;
